import { combineReducers, configureStore } from "@reduxjs/toolkit";
import commonSlice, { CommonStateType } from "./common";

const rootReducer = combineReducers({
  common: commonSlice,
});

export interface RootState {
  common: CommonStateType;
}

export default configureStore({
  reducer: rootReducer,
});
